(function() {
  let cartLocked = false;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-item__add-button');
    if (!btn) return;

    if (cartLocked) {
      e.preventDefault();
      return;
    }

    cartLocked = true;
    setTimeout(() => (cartLocked = false), 1200); 
  });

  
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add.js')) {
      if (window._addingToCart) {
        console.warn('Blocked duplicate add.js call');
        return Promise.resolve(new Response('{}', { status: 200 }));
        
      }
      window._addingToCart = true;
      setTimeout(() => (window._addingToCart = false), 1200);
    }
    return originalFetch.apply(this, args);
  };
})();